import { useQuery } from '@tanstack/react-query';
import {
  fetchSubscriptionActivity,
  getActivityMood,
  getVisibleActivityMetrics,
} from '../lib/subscription-journey/activity-metrics';
import { useAuth } from './useAuth';

export const SUBSCRIPTION_ACTIVITY_QUERY_KEY = ['subscription', 'activity'] as const;

/**
 * Billing summary metrics (D). `metrics` holds only countable values; an empty
 * array (loading, error, or nothing countable) means "hide the strip" - never
 * render zeros for unknown data.
 */
export function useSubscriptionActivity(options: { enabled?: boolean } = {}) {
  const { user } = useAuth();
  const query = useQuery({
    queryKey: [...SUBSCRIPTION_ACTIVITY_QUERY_KEY, user?.id ?? null],
    queryFn: fetchSubscriptionActivity,
    enabled: (options.enabled ?? true) && Boolean(user?.id),
    // The server caches for 5 minutes; match it.
    staleTime: 5 * 60 * 1000,
  });
  const metrics = getVisibleActivityMetrics(query.data);
  return {
    activity: query.data ?? null,
    metrics,
    mood: getActivityMood(query.data),
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
}
